import * as React from 'react';
import { Flex } from '../../../components/common/flex';
import { SelectOption } from '../../../components/common/select';
import { StatusLabel } from '../../../components/common/status_label';
import { IColumnProps } from '../../../components/common/table';
import { ItemType } from '../../../components/common/tabs';
import ChevronRight from '../../../components/icons/chevron_right';
import { BookingsTableBook, TypeBookAction, TypeBookType, TypeTableSize } from '../dto';

const STATUS_COLUMN_PROPS: IColumnProps<BookingsTableBook> = {
  title: 'Статус',
  width: 146,
  dataIndex: 'dummy_status_name',
  render: (text, book) => (
    <Flex vertical justify={'start'} align={'start'} style={{ marginTop: '-4px' }} gap={'small'}>
      {book.from_camp_site && <div className={'my-site-label typography-regular-0'}>Мой сайт</div>}
      <StatusLabel dummyStatus={text} isBooking={book.is_booking} />
    </Flex>
  ),
};

export const TABLE_PROPS: Record<TypeTableSize, IColumnProps<BookingsTableBook>[]> = {
  SMALL: [
    { title: '№ брони', width: 72, dataIndex: 'id' },
    { ...STATUS_COLUMN_PROPS, width: 132 },
    {
      title: 'Имя гостя и номер',
      width: 'auto',
      render: (_, book) => (
        <>
          <div className={'typography-medium-2'}>{book.full_name}</div>
          {book.apartments.map((apartment, i) => (
            <div style={{ marginTop: '4px' }} key={i}>
              {apartment}
            </div>
          ))}
        </>
      ),
    },
    {
      title: 'Заезд и выезд',
      width: 96,
      className: 'booking-list__cell_dates',
      render: (_, book) => (
        <>
          <div>→ {book.arrival}</div>
          <div style={{ marginTop: '3px' }}>← {book.departure}</div>
        </>
      ),
    },
    { title: 'Дата брони', width: 96, dataIndex: 'created_at' },
    {
      title: 'Стоимость',
      width: 142,
      render: (_, book) => (
        <Flex gap={'middle'}>
          <div style={{ width: '92px' }}>
            <div className={'typography-medium-2'}>{book.total_cost}</div>
            <div style={{ marginTop: '3px' }}>{book.money_client_must_pay}</div>
            <div className={'typography-light-3'}>при заселении</div>
          </div>
          <ChevronRight />
        </Flex>
      ),
    },
  ],
  MIDDLE: [
    { title: '№ брони', width: 80, dataIndex: 'id' },
    STATUS_COLUMN_PROPS,
    {
      title: 'Имя гостя и номер',
      width: 'auto',
      render: (_, book) => (
        <Flex vertical gap={4}>
          <div className={'typography-medium-2'}>{book.full_name}</div>
          {book.apartments.map((apartment, i) => (
            <div key={i}>{apartment}</div>
          ))}
        </Flex>
      ),
    },
    {
      title: 'Заезд и выезд',
      width: 112,
      render: (_, book) => (
        <Flex vertical gap={3}>
          <div>→ {book.arrival}</div>
          <div>← {book.departure}</div>
        </Flex>
      ),
    },
    { title: 'Дата брони', width: 104, dataIndex: 'created_at' },
    { title: 'Стоимость', width: 108, dataIndex: 'total_cost', className: 'typography-medium-2' },
    {
      title: 'Оплата при заселении',
      width: 142,
      dataIndex: 'money_client_must_pay',
      render: (text, book) => (
        <Flex gap={'middle'}>
          <span style={{ width: 92 }}>{text}</span>
          <ChevronRight />
        </Flex>
      ),
    },
  ],
  LARGE: [
    { title: '№ брони', width: 88, dataIndex: 'id', className: 'booking-list__cell_id' },
    STATUS_COLUMN_PROPS,
    { title: 'Имя гостя', width: 216, dataIndex: 'full_name', className: 'typography-medium-2' },
    {
      title: 'Номер',
      width: 'auto',
      dataIndex: 'apartments',
      render: (_, book) => book.apartments.map((apartment, i) => <div key={i}>{apartment}</div>),
    },
    { title: 'Заезд', width: 104, dataIndex: 'arrival' },
    { title: 'Выезд', width: 104, dataIndex: 'departure' },
    { title: 'Дата брони', width: 104, dataIndex: 'created_at' },
    { title: 'Стоимость', width: 108, dataIndex: 'total_cost', className: 'typography-medium-2' },
    {
      title: 'Оплата при заселении',
      width: 142,
      dataIndex: 'money_client_must_pay',
      render: (text, book) => (
        <Flex gap={'middle'}>
          <span style={{ width: 92 }}>{text}</span>
          <ChevronRight />
        </Flex>
      ),
    },
  ],
};

export const BOOK_STATUSES: Array<SelectOption> = [
  { label: 'Любой статус', value: '' },
  { label: 'Новое', value: 'new' },
  { label: 'Заехал', value: 'arrived' },
  { label: 'Выехал', value: 'done' },
  { label: 'Отменено', value: 'canceled' },
  { label: 'Незаезд', value: 'not_arrived' },
];

export const BOOK_TYPES: Array<ItemType<TypeBookType>> = [
  { key: '', label: 'Все' },
  { key: 'new', label: 'Новые' },
  { key: 'pending_arrival', label: 'Ожидают заселения' },
  { key: 'living', label: 'Проживающие' },
  { key: 'pending_departure', label: 'Ожидают выселения' },
  { key: 'left', label: 'Выехали' },
  { key: 'canceled', label: 'Отмененные' },
];

export const BOOK_ACTION_SUCCESS_MESSAGE: Record<TypeBookAction, string> = {
  approve: 'Спасибо, информация по подтверждению бронирования получена',
  correct:
    'Спасибо, информация по корректировке бронирования получена. ' +
    'В ближайшее время с вами свяжется менеджер и внесет изменения в заявку',
  reject: 'Спасибо, информация по отмене бронирования получена',
};
